<template>
    <div class="machineinfo">
        <!--弹出框-->
        <el-dialog title="编辑" :visible.sync="dialogVisible" width="500px;" :close="handleClose">
            <div class="title">
                <span class="checktip"></span>处理进程：
                <el-select v-model="dialogData.type" placeholder="处理进程" class="inputWidth1">
                    <el-option v-for="item in activateOptions" :key="item.id" :label="item.name" :value="item.id">
                    </el-option>
                </el-select>
            </div>
            <div class="title">
                <span class="checktip"></span>描述：
                <el-input v-model="dialogData.describe" style="width: 350px;"  size="medium" placeholder="描述"></el-input>
            </div>

            <span slot="footer" class="dialog-footer">
		    <el-button @click="dialogVisible = false">取 消</el-button>
		    <el-button type="primary" @click="handleConfirm()">确 定</el-button>
		  </span>
        </el-dialog>

        <div class="dataTag">
            <div class="handle">
                <div class="fl">
                    <img src="../assets/img/dataIcon.png" style="vertical-align: middle;" />
                    <span class="" style="display: inline-block; vertical-align: middle;">数据列表</span>
                </div>
            </div>
            <!--零件筛选-->
            <div class="filtrateMain">
                <el-row :gutter="15" style="text-align: center;">
                    <el-col :span="4">
                        <el-select v-model="filtrateData.type" placeholder="处理进程" class="inputWidth1">
                         <el-option v-for="item in activateOptions" :key="item.id" :label="item.name" :value="item.id">
                         </el-option>
                        </el-select>
                    </el-col>
                    <el-col :span="4" style="line-height: 40px;">
                        <el-button type="primary" size="mini" @click="handleSearch()">查询</el-button>
                        <el-button type="warning" size="mini" @click="handleReset()">重置</el-button>
                    </el-col>
                </el-row>
                <!--筛选结束-->
            </div>
            <!--列表内容-->
            <div class="tableData" style="text-align: center;">
                <el-table
                        ref="multipleTable"
                        :data="tableData"
                        border
                        style="width: 100%;border-bottom: 1px solid #ddd;">
                    <el-table-column type="index" label="序号" width="60px">
                    </el-table-column>
                    <el-table-column prop="code" label="机台号" width="200px">
                    </el-table-column>
                    <el-table-column prop="version" label="版本" width="100px">
                    </el-table-column>
                    <el-table-column prop="typeName"  label="处理进程" width="100px">
                    </el-table-column>
                    <el-table-column prop="describe" label="描述" width="400">
                    </el-table-column>
                    <el-table-column prop="createTime" label="创建时间" width="180px">
                    </el-table-column>

                    <el-table-column  label="文件" width="150">
                        <template slot-scope="scope">
                         <a :href= scope.row.fileUrl style="color: #1ABC9C;">下载文件</a>
                        </template>
                    </el-table-column>

                    <el-table-column label="操作">
                        <template slot-scope="scope">
                            <a href="javascript:void(0)" @click="handleEdit(scope.$index, scope.row)" style="color: #1ABC9C;">编辑</a>
                            <a href="javascript:void(0)" @click="handleDelete(scope.$index, scope.row)" style="color: #1ABC9C;">删除</a>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
            <!--分页-->
            <div class="page">
                <el-pagination
                        background
                        :current-page="tableDataArr.currentPage"
                        :page-sizes="[10,20,30,40]"
                        :page-size="tableDataArr.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="tableDataArr.totalSize"
                        @current-change="handleCurrentChange"
                        @size-change="handleSizeChange">
                </el-pagination>
            </div>
        </div>
    </div>
</template>

<script>
    export default {
        name: "carsh",
        data() {
            return {
                tableDataArr: {
                    currentPage: 1,
                    pageSize: 10,
                    totalSize: 0
                },
                filtrateData: {
                },
                tableData: [],
                activateOptions: [{
                    id: 1,
                    name: "未处理"
                }, {
                    id: 2,
                    name: "已处理"
                }],
                dialogData: {
                    id:"",
                    describe:"",
                    type:'',
                },
                dialogVisible:false,
            }
        },
        methods: {
            getCarsh() {
                const formData = new FormData();
                formData.append("currentPage", this.tableDataArr.currentPage)
                formData.append("pageSize", this.tableDataArr.pageSize)
                formData.append("type", this.filtrateData.type)

                this.$fly.post("zcvrVideoApi/dump/getDump/"+sessionStorage.getItem('sessionId'), formData).then(
                    (success) => {
                        console.log(success.data.data.items)
                        this.tableData = success.data.data.items
                        let len = this.tableData.length;
                        for (var i=0;i<len;i++){
                            this.tableData[i].typeName = this.tableData[i].type == 1 ? '未处理':'已处理'
                        }
                        this.tableDataArr.currentPage = success.data.data.currentPage
                        this.tableDataArr.pageSize = success.data.data.pageSize
                        this.tableDataArr.totalSize = success.data.data.totalSize
                    }
                )
            },
            handleClose(){
                this.dialogVisible = false
            },
            handleEdit: function(index, row){
                this.dialogData.describe = row.describe
                this.dialogData.type = row.type
                this.dialogVisible = true
                this.dialogData.id = row.id
            },
            handleDelete: function(index, row){
                this.$confirm('此操作将永久删除该文件, 是否继续?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let url = "zcvrVideoApi/dump/deleteDump/"+sessionStorage.getItem('sessionId')+"/"+row.id
                    this.$http.get(url,{emulateJson:true}).then(
                        (success)=> {
//				  				console.log(success)
                            if (success.body.msg == "ok") {
                                this.$message({
                                    message: '删除成功',
                                    type: 'success'
                                });
                                this.getCarsh()
                            } else {
                                this.$message({
                                    message: success.data.msg,
                                    type: 'error'
                                });
                                if (success.data.msg == "该SessionId已经超时") {
                                    this.$message.error("登录超时！请重新登录");
                                    this.$router.push({path: '/', query: ''})
                                }
                            }
                        },
                        (error)=>{
                            console.log("数据连接失败")
                        }
                    )
                }).catch(() => {
                    this.$message({
                        type: 'info',
                        message: '已取消删除'
                    });
                })
            },
            handleSearch: function(){
                if(this.filtrateData.type ==''){
                    this.$message({
                        message: "请选择筛选条件",
                        type: 'info'
                    });
                }else{
                    this.getCarsh()
                }
            },
            handleReset(){
                this.filtrateData.type = ''
                this.getCarsh()

            },
            handleConfirm(){
                const formData = new FormData();
                formData.append("id", this.dialogData.id)
                formData.append("describe", this.dialogData.describe)
                formData.append("type", this.dialogData.type)
                console.log("this.dialogData.type",this.dialogData.type)

                this.$fly.post("zcvrVideoApi/dump/updateDump/"+sessionStorage.getItem('sessionId'), formData).then(
                    (success) => {
                        console.log(success)
                        if(success.data.msg!="ok"){
                            this.$message({
                                type: 'error',
                                message: success.data.msg
                            });
                            if(success.data.msg=="该SessionId已经超时"){
                                this.$message.error("登录超时！请重新登录");
                                this.$router.push({path: '/',query: ''})
                            }
                        }else{
                            this.dialogData = { id:"",
                                describe:"",
                                type:'',}
                            this.dialogVisible = false
                            this.getCarsh()
                        }
                    },
                    (error)=>{
                        console.log("数据连接失败")
                    })
            },
            handleCurrentChange(cur){
                this.tableDataArr.currentPage = cur
                this.getCarsh()
            },
            handleSizeChange(size){
                this.tableDataArr.pageSize = size
                this.getCarsh()
            }
        },
         mounted() {
            this.getCarsh()
        },
    }

</script>

<style scoped>
    .fl {
        float: left;
    }
    .fr {
        float: right;
    }
    .cf {
        overflow: hidden;
    }
    .title{
        padding: 20px 0;
    }
    .dataTag{
        width: 1400px;
        border: 1px solid #ccc;
        margin: auto;
        margin-top: 30px;
    }
    .dataTag .handle{
        height: 60px;
        line-height: 60px;
        background: #ededed;
        padding: 0 40px;
        border-bottom: 1px solid #ccc;
    }
    a {
        margin: 3px;
    }
    .page{
        text-align: center;
        padding: 10px 0;
        background: rgb(246, 247, 249);
    }
    .disabledInput{
        width: 100%;
        border: none;
        background: rgba(0,0,0,0);
        text-align: center;
    }

    .filtrateMain{
        background: #fff;
        padding: 10px;
    }
    .filtrateMain .inputWidth{
        width: 90%;
    }
</style>
